import { createGlobalStyle } from 'styled-components'

export const WebviewNativeStyles = createGlobalStyle<{ isInsideWebView?: boolean }>`
  ${props =>
    props.isInsideWebView
      ? `
    html, body {
      overscroll-behavior: none;
      overscroll-behavior-y: none;
      -webkit-overflow-scrolling: touch;
    }

    /* Prevenir seleção de texto globalmente e otimizações gerais */
    * {
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      -webkit-tap-highlight-color: transparent;
      touch-action: pan-x pan-y pinch-zoom;
      -webkit-overflow-scrolling: touch;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    /* Permitir seleção de texto apenas em inputs e áreas de texto */
    input, textarea, [contenteditable="true"] {
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      touch-action: auto;
      font-size: 16px;
    }

    /* Melhorar feedback tátil - remove delay de 300ms em toques */
    a, button, [role="button"] {
      touch-action: manipulation;
      -webkit-touch-callout: none;
    }

    /* Prevenir pull-to-refresh no Android Chrome */
    body {
      overscroll-behavior-y: contain;
    }

    /* Prevenir menu de contexto em long press (iOS/Android) */
    img, a {
      -webkit-touch-callout: none;
    }

    /* Permitir menu de contexto apenas em inputs de texto quando necessário */
    input[type="text"],
    input[type="email"],
    input[type="password"],
    input[type="search"],
    input[type="tel"],
    input[type="url"],
    textarea {
      -webkit-touch-callout: default;
    }

    /* Melhorar scroll nativo */
    .scrollable, [data-scrollable], [overflow="auto"], [overflow="scroll"] {
      -webkit-overflow-scrolling: touch;
      scroll-behavior: smooth;
    }

    @font-face {
      font-family: "Sharon Sans";
      font-weight: 400;
      font-style: normal;
      src: url("/fonts/SharonSans-Regular.woff2") format("woff2"),
           url("/fonts/SharonSans-Regular.woff") format("woff");
      font-display: swap;
    }

    @font-face {
      font-family: "Sharon Sans";
      font-weight: 600;
      font-style: normal;
      src: url("/fonts/SharonSans-Medium.woff2") format("woff2"),
           url("/fonts/SharonSans-Medium.woff") format("woff");
      font-display: swap;
    }

    @font-face {
      font-family: "Sharon Sans";
      font-weight: 700;
      font-style: normal;
      src: url("/fonts/SharonSans-Bold.woff2") format("woff2"),
           url("/fonts/SharonSans-Bold.woff") format("woff");
      font-display: swap;
    }
  `
      : ''}
`
